<template>
  <div class="card" :class="[`card--${card.kind}`, { 'card--newest': newest, 'card--deadly': deadly }]">
    <img
      class="card__art"
      :src="`${base}card-art/${card.id}.jpg`"
      :alt="label"
      draggable="false"
    >
    <span v-if="left > 0" class="card__left" :title="`${left} treasure still on this card`">
      {{ left }}
    </span>
  </div>
</template>

<script>
import { cardById } from '@/engine/deck';
import { CARD_KINDS } from '@/engine/constants';

// One quest card, face up on the path.
//
// The art is the whole card - these are pictures, not numbers with a border
// the way No Thanks!'s are, so there is no text overlay except the treasure
// still lying on it. `alt` carries the identity for anyone who can't see the
// picture, which matters more here than in the sibling game: "a snake" is the
// entire content of a snake card.
export default {
  name: 'CardFace',
  props: {
    cardId: { type: String, required: true },
    // Treasure still on this card, waiting for someone to leave and take it.
    left: { type: Number, default: 0 },
    newest: { type: Boolean, default: false },
    // The second of its type - this is the card that ended the round.
    deadly: { type: Boolean, default: false },
  },
  data() {
    return { base: process.env.BASE_URL || '/' };
  },
  computed: {
    card() {
      return cardById(this.cardId) || { id: this.cardId, kind: 'treasure', value: 0 };
    },
    label() {
      if (this.card.kind === CARD_KINDS.TREASURE) return `Treasure worth ${this.card.value}`;
      if (this.card.kind === CARD_KINDS.ARTIFACT) return 'An artifact';
      return `Hazard: ${this.card.hazard}`;
    },
  },
};
</script>
